export const GetTrades = () => {
    const trades = [
        {
            "description": "Accountant",
            "webBranding": "CAQSC",
            "keywords": "Bookkeeper, Accountancy, Accountants, Bookkeeping, Book Keepers",
            "priority": "125",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Acoustic Engineer",
            "webBranding": "CAQTL",
            "keywords": "Acoustics",
            "priority": "1000",
            "products": "CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Actuarial Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Actuary, Actuaries",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Actuary",
            "webBranding": "CAQSC",
            "keywords": "Actuarial Consultant, Actuaries",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Acupuncturist",
            "webBranding": "CAQSC",
            "keywords": "Beautician, Acupuncture, Physiotherapy, Physiotherapist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Administration",
            "webBranding": "CAQSC",
            "keywords": "Clerical Services",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Advertising",
            "webBranding": "CAQSC",
            "keywords": "Marketing",
            "priority": "116",
            "products": "CAQGT,CAQSC"
        },
        {
            "description": "Advertising Agency",
            "webBranding": "CAQSC",
            "keywords": "Marketing",
            "priority": "117",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Advertising Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Marketing",
            "priority": "118",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Aerial & Satellite Dish Erector",
            "webBranding": "CAQTL",
            "keywords": "Television Engineer, Aerial Erector, Satellite Dish Installer, TV Installer",
            "priority": "58",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Agricultural Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Farming Consultancy",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Agricultural Contractor (ex stock handling)",
            "webBranding": "CAQTL",
            "keywords": "Farming Contractor, Agricultural Engineer",
            "priority": "75",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Air Conditioning Engineer",
            "webBranding": "CAQTL",
            "keywords": "Heating, Ventilation, HVAC, AC Engineer, Ductwork Installer, H&V, Refrigeration Engineer",
            "priority": "18",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Alarm Installer",
            "webBranding": "CAQTL",
            "keywords": "Fire Alarm Installer, Burglar Alarm Installer, Redcare, CCTV, Security System Installers, Door Entry System Installer",
            "priority": "47",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Arbitrator",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Architect",
            "webBranding": "CAQSC",
            "keywords": "Architecture, Building Consultant, Building Design",
            "priority": "94",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Aromatherapist",
            "webBranding": "CAQSC",
            "keywords": "Beautician",
            "priority": "124",
            "products": "CAQSC"
        },
        {
            "description": "Artexer",
            "webBranding": "CAQTL",
            "keywords": "Plasterer, Plastering, Ceiling Contractor",
            "priority": "22",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Artist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Artistic Painters Sculpters or Potters (Ex metal & wood working)",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Asbestos Removal",
            "webBranding": "CAQTL",
            "keywords": "Asbestos Removers, Asbestos Surveyors",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Auctioneer",
            "webBranding": "CAQSC",
            "keywords": "Valuer, Valuers",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Auditing",
            "webBranding": "CAQSC",
            "keywords": "Accountancy, Accountants",
            "priority": "126",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Author",
            "webBranding": "CAQSC",
            "keywords": "Novelist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Automatic Door Installation",
            "webBranding": "CAQTL",
            "keywords": "Roller Shutter Doors Installers, Electronic Gate Installer, Door Entry System Installer",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Awning Erector",
            "webBranding": "CAQTL",
            "keywords": "Awning Installation",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Banksman",
            "webBranding": "CAQSC",
            "keywords": "Banksmen",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Barrister",
            "webBranding": "CAQSC",
            "keywords": "Solicitor",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Bath Resurfacer",
            "webBranding": "CAQTL",
            "keywords": "Bathroom Installer, Plumbing Contractor",
            "priority": "61",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Bathroom Design",
            "webBranding": "CAQSC",
            "keywords": "Bathroom Installer, Plumbing Contractor",
            "priority": "60",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Bathroom Installation",
            "webBranding": "CAQTL",
            "keywords": "Plumbing Contractor, Bathroom & Kitchen Installer, Kitchen & Bathroom Installer",
            "priority": "59",
            "products": "CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Beautician including Hairdressing",
            "webBranding": "CAQSC",
            "keywords": "Manicurist, Pedicurist, Beauty Treatment Provider, Hairdresser, Hairdressing, Salon",
            "priority": "119",
            "products": "CAQPI,CAQSI,CAQSC"
        },
        {
            "description": "Beautician mobile or renting a chair in a salon (Ex massage and aromatherapy)",
            "webBranding": "CAQSC",
            "keywords": "Manicurist, Pedicurist, Beauty Treatment Provider, Hairdresser, Hairdressing, Salon",
            "priority": "120",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Bedroom Furniture Installation",
            "webBranding": "CAQTL",
            "keywords": "Furniture Installer",
            "priority": "62",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Bill Posters",
            "webBranding": "CAQTL",
            "keywords": "Flyers",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Boiler Services (Domestic)",
            "webBranding": "CAQTL",
            "keywords": "Heating Engineer, GasSafe Engineer, Gas Installer, Boiler Maintenance, Gas Engineer, Heating & Plumbing Engineer, Plumbing & Heating Engineer, Plumbing Contractor",
            "priority": "37",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Bookkeeper",
            "webBranding": "CAQSC",
            "keywords": "Accountancy, Accountants, Bookkeeping, Book Keepers",
            "priority": "127",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Bookmakers - On Course",
            "webBranding": "CAQSC",
            "keywords": "Bookies, Turf Accountants",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Bricklayer",
            "webBranding": "CAQTL",
            "keywords": "House Building, Building Labourers, Wall Builders, Repointing, Brickwork, Rendering, Drystone Walling",
            "priority": "6",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Bricklayers & Hod Carrier",
            "webBranding": "CAQTL",
            "keywords": "House Building, Building Labourers, Wall Builders, Repointing, Brickwork, Rendering, Drystone Walling",
            "priority": "7",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Broadband Installer",
            "webBranding": "CAQTL",
            "keywords": "Telephone Engineer, Cabling Engineer, Communications Engineer, Cabling Contractor, Fibre Optic Cable Installer",
            "priority": "57",
            "products": "CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Builder",
            "webBranding": "CAQTL",
            "keywords": "Building Contractor, General Builder, Property Maintenance, Property Maintenance & Repair, Construction, Construction Contractor House Builder, Property Construction, New House Builder, Speculative Builder, Property Repairs, Refurbishment, Extension Building",
            "priority": "1",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Builder (Private Dwellings, Offices & Shops) - Alteration & Repair",
            "webBranding": "CAQTL",
            "keywords": "Building Contractor, General Builder, Property Maintenance, Property Maintenance & Repair, Construction, Construction Contractor House Builder, Property Construction, New House Builder, Speculative Builder, Property Repairs, PDH, Refurbishment, Extension Building",
            "priority": "2",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Builder (Private Dwellings, Offices & Shops) - New Build",
            "webBranding": "CAQTL",
            "keywords": "Building Contractor, General Builder, Property Maintenance, Property Maintenance & Repair, Construction, Construction Contractor House Builder, Property Construction, New House Builder, Speculative Builder, Property Repairs, PDH, Refurbishment, Extension Building",
            "priority": "3",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Building Management Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Facilities Management, Facility Services, Building Services",
            "priority": "111",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Business Consultant or Advisor",
            "webBranding": "CAQSC",
            "keywords": "Business Consultancy",
            "priority": "112",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Butler",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC,CAQPI"
        },
        {
            "description": "Cake Making & Decorating",
            "webBranding": "CAQSC",
            "keywords": "Baker, Bakery",
            "priority": "1000",
            "products": "CAQSI,CAQSC"
        },
        {
            "description": "Calligraphist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Canvasser",
            "webBranding": "CAQSC",
            "keywords": "Marketing, Advertising",
            "priority": "1000",
            "products": "CAQSC,CAQPI"
        },
        {
            "description": "Car Hirers",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Car Valeter",
            "webBranding": "CAQSC",
            "keywords": "Car Washers, Mobile Valeters, Valeting",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Car Window Etching",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC"
        },
        {
            "description": "Career Advisory Service",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Caretaker",
            "webBranding": "CAQSC",
            "keywords": "Maintenance",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Carpenter",
            "webBranding": "CAQTL",
            "keywords": "Carpentry, Joinery, Carpenter & Joiner, Carpentry & Joinery, Bedroom Fitters, Stair Manufacturers, Door Installation, Kitchen Fitters, Kitchen Manufacturers, Window Frame Installers",
            "priority": "8",
            "products": "CAQCA,CAQGT,CAQTL,CAQPI"
        },
        {
            "description": "Carpenters/Joiners - Roofwork",
            "webBranding": "CAQTL",
            "keywords": "Roof Truss Installation, Timber Frame Construction",
            "priority": "28",
            "products": "CAQTL"
        },
        {
            "description": "Carpet & Upholstery Cleaner",
            "webBranding": "CAQTL",
            "keywords": "Carpet Cleaners, French Polishers",
            "priority": "39",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Carpet Fitter",
            "webBranding": "CAQTL",
            "keywords": "Flooring, Flooring Contractor",
            "priority": "38",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Carrier",
            "webBranding": "CAQSC",
            "keywords": "Courier",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Cartography",
            "webBranding": "CAQSC",
            "keywords": "Mapping, Drawing",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Cartoonist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Caterer",
            "webBranding": "CAQTL",
            "keywords": "Catering, Catering Services, Mobile Food",
            "priority": "147",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Caterer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "148",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Cavity Wall Insulation",
            "webBranding": "CAQTL",
            "keywords": "Insulation Contractors, Insulators, Wall Insulation,",
            "priority": "95",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "CCTV Installation",
            "webBranding": "CAQTL",
            "keywords": "Fire Alarm Installer, Burglar Alarm Installer, Redcare, CCTV, Security System Installers, Door Entry System Installer",
            "priority": "48",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Ceiling Contractor",
            "webBranding": "CAQTL",
            "keywords": "Ceiling, Wall & Floor Tiler, Artexer, Artexing, Suspended Ceiling Contractors",
            "priority": "35",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Celebration Cake Maker",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "150",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Chartered Surveyor",
            "webBranding": "CAQSC",
            "keywords": "Surveyor, Land Surveyor, Building Surveyor",
            "priority": "128",
            "products": "CAQSC"
        },
        {
            "description": "Chauffeur",
            "webBranding": "CAQSC",
            "keywords": "Driver",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Chef",
            "webBranding": "CAQSC",
            "keywords": "Caterer, Catering,",
            "priority": "149",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Chimney Flue Installer",
            "webBranding": "CAQSC",
            "keywords": "Boiler Installer",
            "priority": "95",
            "products": "CAQTL"
        },
        {
            "description": "Chimney Sweep",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Chiropodist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Civil Engineering",
            "webBranding": "CAQSC",
            "keywords": "Civil Construction, Groundworkers, Groundworks, Boring Contractors, Drilling Contractors, Civil Engineers, Industrial Engineering, Tunnelling, Moleing, Road Surfacers, Trenching, Hard Landscaping, Land Remediation, Structural Engineering",
            "priority": "31",
            "products": "CAQPI,CAQSC,CAQTL"
        },
        {
            "description": "Cladding Contractor",
            "webBranding": "CAQTL",
            "keywords": "Cold Roofing Contractor, Cold Roofer, Fibreglass Roofing, Flat Roofing",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Claims Adjusting",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Claims Assessing",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Cleaner",
            "webBranding": "CAQTL",
            "keywords": "Cleaning Contractor, Domestic Cleaners, Commercial Cleaning, Window Cleaning, Upholstery Cleaning, Pressure Jet wash Cleaning",
            "priority": "23",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Cleaner - Industrial",
            "webBranding": "CAQTL",
            "keywords": "Cleaning Contractor, Domestic Cleaners, Commercial Cleaning, Window Cleaning, Upholstery Cleaning, Pressure Jet wash Cleaning, Drain Cleaning",
            "priority": "25",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Cleaner - internal only (ex industrial)",
            "webBranding": "CAQTL",
            "keywords": "Cleaning Contractor, Domestic Cleaners, Commercial Cleaning, Window Cleaning, Upholstery Cleaning, Pressure Jet wash Cleaning",
            "priority": "24",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Clerical Services",
            "webBranding": "CAQSC",
            "keywords": "Administration, Administrator",
            "priority": "1000",
            "products": "CAQSC,CAQPI"
        },
        {
            "description": "Coach Operators",
            "webBranding": "CAQSC",
            "keywords": "Coach Hire, Minibus Hire",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Commissioners For Oaths",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Compliance Officer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Composer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Computer Consultant",
            "webBranding": "CAQSC",
            "keywords": "IT Consultant, Computer Engineer, Computer Technician, Computer Consultant\nComputer Programming \nComputer Repairs & Maintenance\nComputer Software Developer & Consultant\nComputer Software House\nComputer Support\nComputer Training Services, Software Developer, Software Engineer, Data Engineer, Web Designer",
            "priority": "101",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Computer Repairs & Maintenance",
            "webBranding": "CAQSC",
            "keywords": "IT Consultant, Computer Engineer, Computer Technician, Computer Consultant\nComputer Programming \nComputer Repairs & Maintenance\nComputer Software Developer & Consultant\nComputer Software House\nComputer Support\nComputer Training Services, Software Developer, Software Engineer, Data Engineer, Web Designer",
            "priority": "104",
            "products": "CAQGT,CAQPI,CAQSC,CAQTL"
        },
        {
            "description": "Computer Software Developer & Consultant",
            "webBranding": "CAQSC",
            "keywords": "IT Consultant, Computer Engineer, Computer Technician, Computer Consultant\nComputer Programming \nComputer Repairs & Maintenance\nComputer Software Developer & Consultant\nComputer Software House\nComputer Support\nComputer Training Services, Software Developer, Software Engineer, Data Engineer, Web Designer",
            "priority": "102",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Computer Support",
            "webBranding": "CAQSC",
            "keywords": "IT Consultant, Computer Engineer, Computer Technician, Computer Consultant\nComputer Programming \nComputer Repairs & Maintenance\nComputer Software Developer & Consultant\nComputer Software House\nComputer Support\nComputer Training Services, Software Developer, Software Engineer, Data Engineer",
            "priority": "103",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Conference Management",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Conservatory & Porch Erector",
            "webBranding": "CAQTL",
            "keywords": "Double Glazing Contractors, Double Glaziers",
            "priority": "29",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Conveyancing",
            "webBranding": "CAQSC",
            "keywords": "Solicitors",
            "priority": "146",
            "products": "CAQSC"
        },
        {
            "description": "Cooking Services",
            "webBranding": "CAQSC",
            "keywords": "Catering",
            "priority": "151",
            "products": "CAQSC"
        },
        {
            "description": "Counsellor",
            "webBranding": "CAQSC",
            "keywords": "Counselling",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Courier",
            "webBranding": "CAQSC",
            "keywords": "Couriers, Delivery Drivers",
            "priority": "81",
            "products": "CAQGC,CAQHC,CAQSC"
        },
        {
            "description": "Courier (Using Vehicles up to Max Laden Weight 3.5 Tonnes)",
            "webBranding": "CAQSC",
            "keywords": "Couriers, Delivery Drivers",
            "priority": "152",
            "products": "CAQSC"
        },
        {
            "description": "Curtain & Blind Fitter",
            "webBranding": "CAQTL",
            "keywords": "Curtain and Blind Installer",
            "priority": "153",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Curtain Waller",
            "webBranding": "CAQTL",
            "keywords": "Curtain Walling, Renderers, Rendering, Glaziers, Construction",
            "priority": "154",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Damp Proofing and Timber Treatment",
            "webBranding": "CAQTL",
            "keywords": "Damp Proofers, Tanking, Building Sealing",
            "priority": "63",
            "products": "CAQTL"
        },
        {
            "description": "Damp Proofing Contractor",
            "webBranding": "CAQTL",
            "keywords": "Damp Proofers, Tanking, Building Sealing",
            "priority": "62",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Dance Instructor",
            "webBranding": "CAQSC",
            "keywords": "Dance Teacher",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Demolition Contractor",
            "webBranding": "CAQTL",
            "keywords": "Hand Demolition, Debris removal, Debris removers, Ball & Chain, High Reach Demolition, Explosives Demolition Contractors",
            "priority": "156",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Diamond Driller",
            "webBranding": "CAQTL",
            "keywords": "Concrete Drilling Contractors, Concrete Cutters, Groundworkers, Wall Sawing, Concrete Sawing",
            "priority": "157",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Dietician",
            "webBranding": "CAQSC",
            "keywords": "Lifestyle Consultant",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Dog etc Walker Sitter & Carer (inc Kennels and Catteries)",
            "webBranding": "CAQSC",
            "keywords": "Dog walkers, Dog Walking, Pet Sitting",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Dog etc Walker Sitter & Carer (not Kennels and Catteries)",
            "webBranding": "CAQSC",
            "keywords": "Dog walkers, Dog Walking, Pet Sitting",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Dog Grooming",
            "webBranding": "CAQSC",
            "keywords": "Dog walkers, Dog Walking, Pet Sitting",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Dog Walker",
            "webBranding": "CAQSC",
            "keywords": "Dog walkers, Dog Walking, Pet Sitting",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Dog Walker & Pet Sitter",
            "webBranding": "CAQSC",
            "keywords": "Dog walkers, Dog Walking, Pet Sitting",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Domestic Appliance Installation & Repair",
            "webBranding": "CAQTL",
            "keywords": "Washing Machine Engineer, Machine Technician, Boiler Engineer",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Domestic Chair/Stair Lift Installation",
            "webBranding": "CAQTL",
            "keywords": "Lift Contractors, Lift Installers",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Domestic Shed & Garage Erector",
            "webBranding": "CAQTL",
            "keywords": "Building Contractor, Shed Erection, Car Port Installers, Awning Installation",
            "priority": "64",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Double Glazing Installation",
            "webBranding": "CAQTL",
            "keywords": "Glaziers, Window Installers, Window Manufacturers, Sunpipe Installers, Window Frame Manufacturers, Window Frame Installers, Glass Fitters, Conservatory Installers",
            "priority": "26",
            "products": "CAQCA,CAQGT,CAQTL,CAQPI"
        },
        {
            "description": "Draft Proofing Installer",
            "webBranding": "CAQTL",
            "keywords": "Draft Proofer",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Drain Cleaner",
            "webBranding": "CAQTL",
            "keywords": "Drain Maintenance, Culvert Clearance, Guttering Cleaning",
            "priority": "51",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Draughtsman",
            "webBranding": "CAQSC",
            "keywords": "Technical Drawing",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "DressMaker, Tailor or Curtain Maker",
            "webBranding": "CAQSC",
            "keywords": "Seamstress",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Dry Lining Contractor",
            "webBranding": "CAQTL",
            "keywords": "Dry Liner, Plasterer, Artexer, Artexing,",
            "priority": "50",
            "products": "CAQCA,CAQGT,CAQTL,CAQPI"
        },
        {
            "description": "Drystone Waller",
            "webBranding": "CAQTL",
            "keywords": "Walling Contractor",
            "priority": "158",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Ductwork Installation",
            "webBranding": "CAQTL",
            "keywords": "Pipework Installer, HVAC Engineer, Steel Duct Installer, Air Conditioning Engineer",
            "priority": "65",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Electrical Appliance Servicing",
            "webBranding": "CAQTL",
            "keywords": "Washing Machine Engineer, Machine Technician, Boiler Engineer",
            "priority": "13",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Electrical Contractor",
            "webBranding": "CAQTL",
            "keywords": "Electrical Contracting, Electrical Engineer, Electrical Engineering, Wiring, 3 Phase Electrical, Machinery Engineer, Light Fitters, Industrial Electrical Contractor, Lighting Installation, Electrician",
            "priority": "12",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Electrical Tagging",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Electrical Testing",
            "webBranding": "CAQTL",
            "keywords": "PAT Testing, PAT Testers",
            "priority": "12",
            "products": "CAQTL"
        },
        {
            "description": "Electrician",
            "webBranding": "CAQTL",
            "keywords": "Electrical Contracting, Electrical Engineer, Electrical Engineering, Wiring, 3 Phase Electrical, Machinery Engineer, Light Fitters, Industrial Electrical Contractor, Lighting Installation",
            "priority": "11",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Employment Agency",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "159",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Energy Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Renewable Energy Consultancy, Renewable Energy, Green Deal Consultant, Green Deal Assessor",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Engineer",
            "webBranding": "CAQTL",
            "keywords": "Mechanical Engineer, Civil Engineer, Heating Engineer, Structural Engineer, Electrical Engineer, Welding Engineers, Telecommunications Engineers",
            "priority": "66",
            "products": "CAQPI,CAQTL"
        },
        {
            "description": "Engineers - Agricultural/ Construction Plant Ex Heat",
            "webBranding": "CAQTL",
            "keywords": "Agricultural Engineers",
            "priority": "74",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - conveyors",
            "webBranding": "CAQTL",
            "keywords": "Conveyor & Belt Engineers, Production Machinery Engineers",
            "priority": "72",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Fire Extinguisher Service",
            "webBranding": "CAQTL",
            "keywords": "Fire Safety Appliance Installers, Fire Protection Installers, Fire Equipment Providers and Testers",
            "priority": "67",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Fork Lift",
            "webBranding": "CAQTL",
            "keywords": "Mechanical Fork Lift Engineers, Mechanical Engineers",
            "priority": "73",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Garage Equipment",
            "webBranding": "CAQTL",
            "keywords": "Motor Machinery Engineering, Welders, Fabricators",
            "priority": "71",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - General Machinery / Machine Tool Repair ex heat",
            "webBranding": "CAQTL",
            "keywords": "Tooling, Mechanical Machinery repairs",
            "priority": "70",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Hydraulic / Pneumatic",
            "webBranding": "CAQTL",
            "keywords": "Hydrualic Engineers, Air Pressure Specialists, Pump Installers, Mechanical Engineering, Gas System Installers",
            "priority": "68",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Engineers - Pipework",
            "webBranding": "CAQTL",
            "keywords": "Pipe & Ductwork Engineers, Gas Pipe Engineers,",
            "priority": "69",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Pumps",
            "webBranding": "CAQTL",
            "keywords": "Hydrualic Engineers, Air Pressure Specialists, Pump Installers, Mechanical Engineering, Gas System Installers",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Security",
            "webBranding": "CAQTL",
            "keywords": "Security Contractors",
            "priority": "49",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - sprinkler",
            "webBranding": "CAQTL",
            "keywords": "Plumbing Engineers, Sprinkler System Installers, Fire Suppression System Installatiuon",
            "priority": "110",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - staircases railings gates balconies and balustrades",
            "webBranding": "CAQTL",
            "keywords": "Structural Engineers, Welding & Fabrication Welding Engineers, Fabricators, Steel Fabricators, Railings Installers",
            "priority": "107",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - stairlifts",
            "webBranding": "CAQTL",
            "keywords": "Lift Engineers",
            "priority": "109",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - Swimming Pool",
            "webBranding": "CAQTL",
            "keywords": "Swimming Pool Contractors, Swimming Pool Construction",
            "priority": "108",
            "products": "CAQTL"
        },
        {
            "description": "Engineers - wrought iron work",
            "webBranding": "CAQTL",
            "keywords": "Welding & Fabrication Welding Engineers, Fabricators, Steel Fabricators, Railings Installers",
            "priority": "106",
            "products": "CAQTL"
        },
        {
            "description": "Engraver",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Environmental Health Consultant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI"
        },
        {
            "description": "Estate Agency",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "144",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Exhibition Organiser",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Exhibition Stand Erector",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Fabricator",
            "webBranding": "CAQTL",
            "keywords": "Welder, Welding & Fabrication Welding Engineers, Fabricators, Steel Fabricators, Railings Installers",
            "priority": "121",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Farrier",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC"
        },
        {
            "description": "Fencing Contractor",
            "webBranding": "CAQTL",
            "keywords": "Fencers",
            "priority": "52",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Feng Shui Consultant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Financial Advisory Service",
            "webBranding": "CAQSC",
            "keywords": "Financial Advisors, Independent Financial Advisor",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Financial Market Trading",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSI,CAQSC"
        },
        {
            "description": "Financial Services",
            "webBranding": "CAQSC",
            "keywords": "Financial Advisors, Independent Financial Advisor, Insurance, Broking",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fire Proofing and  Fire Protection Engineers",
            "webBranding": "CAQTL",
            "keywords": "Fire Safety Appliance Installers, Fire Protection Installers, Fire Equipment Providers and Testers, Fire Break installation, Fireproof Paint Applications",
            "priority": "53",
            "products": "CAQTL"
        },
        {
            "description": "Fire Surround Installation",
            "webBranding": "CAQTL",
            "keywords": "Fire Place Installers, Gas Engineers, GasSafe Engineers",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Fitness and/or Aerobic Instructors and the like (Excluding Martial Arts)",
            "webBranding": "CAQSC",
            "keywords": "Perosnal Fitness Coach, Sports Coach",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fitted Furniture Installer",
            "webBranding": "CAQTL",
            "keywords": "Wardrobe Manufacturers, Bedroom Furniture Manfacturers, carpenters 7 Joiners",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Floor Screeding",
            "webBranding": "CAQTL",
            "keywords": "Floor Surfacing, Resin Flooring, Floor Tiling, Carpet Fitting",
            "priority": "34",
            "products": "CAQTL"
        },
        {
            "description": "Floor Tiler",
            "webBranding": "CAQTL",
            "keywords": "Floor Surfacing, Resin Flooring, Floor Tiling, Carpet Fitting",
            "priority": "33",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Flooring Contractor",
            "webBranding": "CAQTL",
            "keywords": "Floor Surfacing, Resin Flooring, Floor Tiling, Carpet Fitting, Hard Wood Flooring, Laminate Floor Layers,",
            "priority": "32",
            "products": "CAQCA,CAQGT,CAQTL,CAQPI"
        },
        {
            "description": "Flower & Plant Arranger",
            "webBranding": "CAQSC",
            "keywords": "Florist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Forklift Driving Training",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSI,CAQSC,CAQTL"
        },
        {
            "description": "French Polisher",
            "webBranding": "CAQTL",
            "keywords": "Furniture Restorer",
            "priority": "81",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Function caterers and sandwich delivery (ex mobile snack vans)",
            "webBranding": "CAQTL",
            "keywords": "Catering",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Funeral Celebrant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Furniture Assembly and Repair",
            "webBranding": "CAQTL",
            "keywords": "Furniture Manufacturer",
            "priority": "79",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Furniture Repair &/Or Restoration",
            "webBranding": "CAQTL",
            "keywords": "Furniture Manufacturer, Upholsterer, Upholstery",
            "priority": "80",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Garage Door and Gate Fitter",
            "webBranding": "CAQTL",
            "keywords": "Garage Door Contractor",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Garden Designer",
            "webBranding": "CAQSC",
            "keywords": "Gardening Contractor, Landscape Designer",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Gas Fitter",
            "webBranding": "CAQTL",
            "keywords": "Gas Engineer, Heating Engineer, GasSafe Engineer, Boiler Maintenance Contractor",
            "priority": "16",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Glazier",
            "webBranding": "CAQTL",
            "keywords": "Glaziers, Window Installers, Window Manufacturers, Sunpipe Installers, Window Frame Manufacturers, Window Frame Installers, Glass Fitters, Conservatory Installers",
            "priority": "27",
            "products": "CAQGT,CAQSI,CAQTL"
        },
        {
            "description": "Graphic Designer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Graphologist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "GraveDigger",
            "webBranding": "CAQTL",
            "keywords": "Undertaker",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Groundworker",
            "webBranding": "CAQTL",
            "keywords": "Groundwork Contractor, Groundwork Engineer, Sports Surface Engineers, Surfacing Contractors, Civil Engineers, Landscaping Contractors, Road Surfacing, Car Parks, Paving, Paths and Patio, Tarmac Contractors, Patching, Earth Moving Contractors",
            "priority": "30",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Gutter Cleaner",
            "webBranding": "CAQTL",
            "keywords": "Guttering Cleaning Contractor",
            "priority": "122",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Guttering & Fascia Board Fitter",
            "webBranding": "CAQTL",
            "keywords": "Cold Roofing",
            "priority": "123",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Gym and Fitness Instructor",
            "webBranding": "CAQSC",
            "keywords": "Sports Coach",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Gym Equipment Fitter",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Hairdresser",
            "webBranding": "CAQSC",
            "keywords": "Hairdressing",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Harling and Roughcasting",
            "webBranding": "CAQTL",
            "keywords": "Pebble Dashing, Exterior Wall Contractors, Rendering, Weatherproofing",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Haulier",
            "webBranding": "CAQSC",
            "keywords": "Haulage Contractor",
            "priority": "82",
            "products": "CAQHC,CAQSC"
        },
        {
            "description": "Hauliers inc work in Europe",
            "webBranding": "CAQSC",
            "keywords": "Haulage Contractor",
            "priority": "83",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Health & Safety Consultant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Heating Engineer",
            "webBranding": "CAQTL",
            "keywords": "Gas Engineer, Plumbing & Heating Engineer, GasSafe Engineer, Boiler Maintenance Contractor",
            "priority": "17",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Hoarding Contractors",
            "webBranding": "CAQTL",
            "keywords": "Temporary Fencing Contractors",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Home Tutoring",
            "webBranding": "CAQSC",
            "keywords": "Teacher, Tuturs",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Homeopathy",
            "webBranding": "CAQSC",
            "keywords": "Aromatherapy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "House Clearance",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "House Sitter",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Image Consultant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Information Technology Consultants",
            "webBranding": "CAQSC",
            "keywords": "IT Consultant, Computer Engineer, Computer Technician, Computer Consultant\nComputer Programming \nComputer Repairs & Maintenance\nComputer Software Developer & Consultant\nComputer Software House\nComputer Support\nComputer Training Services, Software Developer, Software Engineer, Data Engineer, Web Designer",
            "priority": "100",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Insulation Engineering",
            "webBranding": "CAQTL",
            "keywords": "Loft Insulation, Cavity wall insulation, insulation Contractors, Loft Contractors",
            "priority": "96",
            "products": "CAQPI,CAQTL"
        },
        {
            "description": "Insurance Agent, Broker or Consultant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Interior Designer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQPI,CAQSC"
        },
        {
            "description": "Interpreter",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Investment",
            "webBranding": "CAQSC",
            "keywords": "Financial Advisors",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Ironing & Home Laundry",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC"
        },
        {
            "description": "Ironing Service",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSI,CAQSC"
        },
        {
            "description": "Joiners",
            "webBranding": "CAQTL",
            "keywords": "Carpentry, Joinery, Carpenter & Joiner, Carpentry & Joinery, Bedroom Fitters, Stair Manufacturers, Door Installation, Kitchen Fitters, Kitchen Manufacturers, Window Frame Installers",
            "priority": "9",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Kitchen Installer",
            "webBranding": "CAQTL",
            "keywords": "Carpentry, Joinery, Carpenter & Joiner, Carpentry & Joinery, Kitchen Fitters, Kitchen Manufacturers, Kitchen Installers",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Landscape Gardener",
            "webBranding": "CAQTL",
            "keywords": "Soft Landscaping, Gardening, Tree Surgery, Gardener,",
            "priority": "19",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Landscape Gardener (Including tree felling / lopping)",
            "webBranding": "CAQTL",
            "keywords": "Soft Landscaping, Gardening, Tree Surgery, Gardener, Tree Felling",
            "priority": "20",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Leaflet Distributor",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC"
        },
        {
            "description": "Licensing Consultancy",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC,CAQPI"
        },
        {
            "description": "LifeStyle Consultant",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Lift Installation",
            "webBranding": "CAQTL",
            "keywords": "Lift Engineers, Escalator Engineers",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Lift Maintenance",
            "webBranding": "CAQTL",
            "keywords": "Lift Engineers, Escalator Engineers",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Linguistics",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Locksmith",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSI,CAQTL"
        },
        {
            "description": "Loft Conversion Contractor",
            "webBranding": "CAQTL",
            "keywords": "Loft Conversions, Loft Installers, Attic Convertors",
            "priority": "98",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Loft Insulation",
            "webBranding": "CAQTL",
            "keywords": "Insulation Contractor, Cavity Wall Insulation",
            "priority": "97",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Manicurist & Pedicurist",
            "webBranding": "CAQSC",
            "keywords": "Beauticians",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Market Trader",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": ""
        },
        {
            "description": "Marketing Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Marketing Agency",
            "priority": "113",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Masseurs",
            "webBranding": "CAQSC",
            "keywords": "Beauticians, Sports Physiotherapists",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Mastic Sealant Contractor",
            "webBranding": "CAQTL",
            "keywords": "Sealing Contractors, Window Sealers",
            "priority": "99",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Mastic Sealant Contractor inc external work",
            "webBranding": "CAQTL",
            "keywords": "Sealing Contractors, Window Sealers",
            "priority": "100",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Milk Delivery",
            "webBranding": "CAQSC",
            "keywords": "Milkman",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Monumental Mason",
            "webBranding": "CAQTL",
            "keywords": "Stone Mason, Stone Cleaning, Stone Restoration, Stone Restorers, Monument Restoration",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Mortgage Broking",
            "webBranding": "CAQSC",
            "keywords": "Mortgage Advisors",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Motor Cycle Courier",
            "webBranding": "CAQSC",
            "keywords": "Delivery Driver",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Music Teacher",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Nail Technician",
            "webBranding": "CAQTL",
            "keywords": "Beautician",
            "priority": "1000",
            "products": "CAQSI,CAQSC,CAQTL"
        },
        {
            "description": "Nail Technician",
            "webBranding": "CAQSC",
            "keywords": "Beautician",
            "priority": "1000",
            "products": "CAQSI,CAQSC,CAQTL"
        },
        {
            "description": "Nutritionist",
            "webBranding": "CAQSC",
            "keywords": "Healthy Lifestyle Consultant, Dietician",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Occupational Therapist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Office Equipment Installer & Repairer",
            "webBranding": "CAQTL",
            "keywords": "Photocopier Engineer, PAT Testing",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Optician",
            "webBranding": "CAQSC",
            "keywords": "Optometrist",
            "priority": "1000",
            "products": "CAQSI,CAQSC"
        },
        {
            "description": "Painter & Decorator",
            "webBranding": "CAQTL",
            "keywords": "Painting & Decorating, Wallpapering, Paint Sprayer, Decorating",
            "priority": "10",
            "products": "CAQCA,CAQGT,CAQTL,CAQPI"
        },
        {
            "description": "Partitioning Contractor",
            "webBranding": "CAQTL",
            "keywords": "Suspended Ceiling Contractors, Dryliners",
            "priority": "38",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Paths, Drives & Patio Cleaner",
            "webBranding": "CAQTL",
            "keywords": "Pressure Jet Wash Cleaners",
            "priority": "41",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Paving Path Drive & Patio Contractor",
            "webBranding": "CAQTL",
            "keywords": "Groundworker, Pavers, Driveway Layers",
            "priority": "40",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Pebble Dasher",
            "webBranding": "CAQTL",
            "keywords": "Rendering, Render",
            "priority": "136",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Pest Controllers",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Photographers",
            "webBranding": "CAQSC",
            "keywords": "Wedding Photography, Photography, Portraits",
            "priority": "1000",
            "products": "CAQPI,CAQSC,CAQTL"
        },
        {
            "description": "Photographers (Excluding Studios)",
            "webBranding": "CAQSC",
            "keywords": "Wedding Photography, Photography, Portraits",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Physiotherapist",
            "webBranding": "CAQSC",
            "keywords": "Sports Physio, Physio, Physiotherapy",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Piano Tuners",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Picture Framer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Plant Hirers - agricultural plant",
            "webBranding": "CAQTL",
            "keywords": "Plant & Tool hire, Tool Hire",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Plant Hirers - amusement machines",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Plant Hirers - mechanically propelled contractors plant",
            "webBranding": "CAQTL",
            "keywords": "Heavy plant hire",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Plant Hirers - non mechanically propelled contractors plant and tools",
            "webBranding": "CAQTL",
            "keywords": "Tool Hire, Tool Merchant",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Plasterer",
            "webBranding": "CAQTL",
            "keywords": "Plastering",
            "priority": "21",
            "products": "CAQCA,CAQGT,CAQTL,CAQPI"
        },
        {
            "description": "Plumber",
            "webBranding": "CAQTL",
            "keywords": "Plumbers, Pipe Installers, Plumbing Engineers,",
            "priority": "14",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Plumbing and Heating Engineer",
            "webBranding": "CAQTL",
            "keywords": "Plumbers, Heating Engineers, Heating & Ventilation",
            "priority": "15",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Private Tutor",
            "webBranding": "CAQSC",
            "keywords": "Teacher",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Project Management",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQTL"
        },
        {
            "description": "Property Maintenance (Ex Hazardous Activities)",
            "webBranding": "CAQTL",
            "keywords": "General Building, Refurbishment, Repair, Clearance, House Clearance, Garden Maintenance, Facility Management, Building Management",
            "priority": "5",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Property Maintenance and Repair",
            "webBranding": "CAQTL",
            "keywords": "General Building, Refurbishment, Repair, Clearance, House Clearance, Garden Maintenance, Facility Management, Building Management",
            "priority": "4",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Public Relation Consultancy",
            "webBranding": "CAQSC",
            "keywords": "PR Consultants",
            "priority": "131",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Publicity Management",
            "webBranding": "CAQSC",
            "keywords": "PR",
            "priority": "132",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Quantity Surveyor",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "130",
            "products": "CAQPI,CAQSC,CAQTL"
        },
        {
            "description": "Recruitment Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Recruitment Agency",
            "priority": "159",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Reflexologist",
            "webBranding": "CAQSC",
            "keywords": "Physiotherapist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Refrigeration Engineer",
            "webBranding": "CAQTL",
            "keywords": "HVAC Engineer, Motor Refrigeration, Cold Room Installation, Temperature Control Technicians",
            "priority": "42",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Removal Contractor",
            "webBranding": "CAQTL",
            "keywords": "Movers, House Clerance",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Rendering Contractor",
            "webBranding": "CAQTL",
            "keywords": "Repointing, Stine work",
            "priority": "133",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Research Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Researcher",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Roller Shutter Door Installation",
            "webBranding": "CAQTL",
            "keywords": "Mechanical Door Installers, Vehicle Lift Installers",
            "priority": "160",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Roof Cladding",
            "webBranding": "CAQTL",
            "keywords": "Cold Roofing, Fibreglass Cladding, Flat roofers, Steel Roofing Fabrication, Roofing Contractors",
            "priority": "44",
            "products": "CAQTL"
        },
        {
            "description": "Roofer",
            "webBranding": "CAQTL",
            "keywords": "Roofing Fabrication, Roofing Contractors, Flat Roofers, Hot Roofers, Cold Roofers, Roofing, Slate Roofing, Pitched roofing, Bitumen Roofing, Flat felt Roofing",
            "priority": "43",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Roofer - Flat (Fibreglass & Resin Only)",
            "webBranding": "CAQTL",
            "keywords": "Flat roofers, Bitumen Roofing, Flat felt Roofing",
            "priority": "46",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Roofer - Slaters, Thatchers & Tilers Only",
            "webBranding": "CAQTL",
            "keywords": "Thatchers, Roof Tilers, Cold Roofers, Fascia Board Installers, Slate Roofing",
            "priority": "45",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Roughcaster",
            "webBranding": "CAQTL",
            "keywords": "Harling, Pebble Dashing",
            "priority": "134",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Sand Blaster",
            "webBranding": "CAQTL",
            "keywords": "Sand Blasting Contractor",
            "priority": "135",
            "products": "CAQTL"
        },
        {
            "description": "Satellite & TV Installers",
            "webBranding": "CAQTL",
            "keywords": "Television Engineer, Aerial Erector, Satellite Dish Installer, TV Installer",
            "priority": "93",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Scaffolder (Domestic)",
            "webBranding": "CAQTL",
            "keywords": "Scaffolding Engineer, Scaffolding Contractor,",
            "priority": "91",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Scaffolder (Industrial)",
            "webBranding": "CAQTL",
            "keywords": "Tank scaffolding, Industrial Scaffolding, Bridge scaffolding",
            "priority": "92",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Screenwriting",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Script Writing",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Sculptor",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Secretarial Services",
            "webBranding": "CAQSC",
            "keywords": "Clerical services",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Security",
            "webBranding": "CAQTL",
            "keywords": "Fire Alarm Installer, Burglar Alarm Installer, Redcare, CCTV, Security System Installers, Door Entry System Installer",
            "priority": "90",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Security",
            "webBranding": "CAQSC",
            "keywords": "Fire Alarm Installer, Burglar Alarm Installer, Redcare, CCTV, Security System Installers, Door Entry System Installer",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Shoe Polisher & Repairer",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Shopfitter",
            "webBranding": "CAQTL",
            "keywords": "Shopfitting, Carpentry & Joinery, Shop Refurbishment, Store Refurbishment",
            "priority": "54",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Shuttering and Formwork",
            "webBranding": "CAQTL",
            "keywords": "Steel Fixing, Concrete Pourers, Civil Engineers, Structural Engineers",
            "priority": "89",
            "products": "CAQTL"
        },
        {
            "description": "Sign Erector",
            "webBranding": "CAQTL",
            "keywords": "Signage",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Sign Writer",
            "webBranding": "CAQTL",
            "keywords": "Signage",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQSC,CAQTL"
        },
        {
            "description": "Skip Hire",
            "webBranding": "CAQTL",
            "keywords": "Waste Contractor",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Skip Hire including Transfer Station",
            "webBranding": "CAQTL",
            "keywords": "Waste management, Recycling",
            "priority": "1000",
            "products": "CAQHC,CAQTL"
        },
        {
            "description": "Solar Panel Installation",
            "webBranding": "CAQTL",
            "keywords": "Solar Panel Installation. PV Installers, Solar Thermal, Renewable Energy Contractor/Consultant, Photo Voltaic Panel Installation, Green Deal Provider, Geothermal,",
            "priority": "88",
            "products": "CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "Solicitor",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Sports Surfacing Contractor",
            "webBranding": "CAQTL",
            "keywords": "Groundworker, Pitch Layer, Sports Surface Laying",
            "priority": "87",
            "products": "CAQTL"
        },
        {
            "description": "Statistician",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Steel Reinforcement",
            "webBranding": "CAQTL",
            "keywords": "Steel Fixer, Steel Fixing, Structural Steel Work, Concrete Pumping",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Stockbroking",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Stone Mason",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "137",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Surveyor of Buildings",
            "webBranding": "CAQSC",
            "keywords": "Building Surveyor",
            "priority": "129",
            "products": "CAQSC, CAQPI"
        },
        {
            "description": "Swimming Pool Installer",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Swimming Pool Maintenance",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Tax Consultancy",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Taxi Driver",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Taxidermist",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC,CAQTL"
        },
        {
            "description": "Teacher",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Teacher & Tutor (Excluding Manual Activities)",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Teacher & Tutor (Excluding Sports Woodworking And Metalworking)",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Telecommunication Engineer",
            "webBranding": "CAQTL",
            "keywords": "Commuication Engineer, Communications Technician, Phone Engineer, Socket Installation, Transmitter Engineer",
            "priority": "57",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Telecommunications Consultancy",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Telegraph Pole Erector",
            "webBranding": "CAQTL",
            "keywords": "Communications Erector, Groundworker",
            "priority": "86",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Telemarketing",
            "webBranding": "CAQSC",
            "keywords": "Contact Centre, Call Centre, Advertising & marketing",
            "priority": "159",
            "products": "CAQSC"
        },
        {
            "description": "Telephone Point / Extension Installation",
            "webBranding": "CAQTL",
            "keywords": "Telecommunications Engineer",
            "priority": "56",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Telephone System (Including wireless signalling installations) & Data Cabling Installers",
            "webBranding": "CAQTL",
            "keywords": "Telecommunications Engineer",
            "priority": "55",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Telesales",
            "webBranding": "CAQSC",
            "keywords": "Contact Centre, Call Centre",
            "priority": "1000",
            "products": "CAQSC,CAQPI"
        },
        {
            "description": "Textile Consultancy",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Ticket Agency",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Timber Decking Contractor",
            "webBranding": "CAQTL",
            "keywords": "Flooring Contractors, Gardener, Property Maintenance",
            "priority": "37",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Tour Guide",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Town Planning",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Traffic Control",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Training Consultant",
            "webBranding": "CAQSC",
            "keywords": "Training Manager, Training Provider",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Translator",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Tree Surgeon",
            "webBranding": "CAQTL",
            "keywords": "Tree Feller",
            "priority": "138",
            "products": "CAQCA,CAQGT,CAQPI,CAQTL"
        },
        {
            "description": "TV & Video Repairing",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQSI,CAQSC"
        },
        {
            "description": "TV and Video Installation",
            "webBranding": "CAQSC",
            "keywords": "TV Engineer, Aerial installer",
            "priority": "1000",
            "products": "CAQGT,CAQPI,CAQSC"
        },
        {
            "description": "Underpinning and Foundation Contractors",
            "webBranding": "CAQTL",
            "keywords": "Groundworkers, Civil Engineers, Piling Engineers, Piling Contractors",
            "priority": "84",
            "products": "CAQCA,CAQTL"
        },
        {
            "description": "Underpinning and Foundation Contractors - other (ex piling)",
            "webBranding": "CAQTL",
            "keywords": "Groundworkers, Civil Engineers, Piling Engineers, Piling Contractors",
            "priority": "85",
            "products": "CAQTL"
        },
        {
            "description": "Underpinning and Foundation Contractors - pdh and commercial (ex piling)",
            "webBranding": "CAQTL",
            "keywords": "Groundworkers, Civil Engineers, Piling Engineers, Piling Contractors",
            "priority": "116",
            "products": "CAQTL"
        },
        {
            "description": "Underwriting Agency",
            "webBranding": "CAQSC",
            "keywords": "Underwriters, Brokers",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Upholsterer",
            "webBranding": "CAQTL",
            "keywords": "Reupholsters, Furniture Refurbishment",
            "priority": "78",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Vacuum Cleaner Repairs and Servicing",
            "webBranding": "CAQTL",
            "keywords": "Domestic Appliance Servicing",
            "priority": "1000",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Valuation - Real Estate",
            "webBranding": "CAQSC",
            "keywords": "Estate Angents",
            "priority": "145",
            "products": "CAQSC"
        },
        {
            "description": "Vending Machine Fillers",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Videographer (Exc. Underwater & Aerial)",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Wall Tiler",
            "webBranding": "CAQTL",
            "keywords": "Ceiling, Wall & Floor Tiler, Bathroom & Kitchen Tiler",
            "priority": "36",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Waste Recyclers",
            "webBranding": "CAQSC",
            "keywords": "Scrap Dealers, Waste Transfer Station, Metal Recyclers, Pick & Place,",
            "priority": "1000",
            "products": "CAQHC,CAQSC,CAQTL"
        },
        {
            "description": "Waste Recycling Site",
            "webBranding": "CAQSC",
            "keywords": "Scrap Dealers, Waste Transfer Station, Metal Recyclers, Pick & Place,",
            "priority": "139",
            "products": "CAQHC,CAQSC,CAQTL"
        },
        {
            "description": "Waste Transfer Services",
            "webBranding": "CAQSC",
            "keywords": "Scrap Dealers, Waste Transfer Station, Metal Recyclers, Pick & Place,",
            "priority": "140",
            "products": "CAQCA,CAQSC,CAQTL"
        },
        {
            "description": "Water Tank Installation",
            "webBranding": "CAQTL",
            "keywords": "Tank Installers, Tank Cleaners, Bowser Suppliers",
            "priority": "141",
            "products": "CAQTL"
        },
        {
            "description": "Web Site Design",
            "webBranding": "CAQSC",
            "keywords": "Internet Technician, Web Technician, IT Consultant",
            "priority": "105",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Welder",
            "webBranding": "CAQTL",
            "keywords": "Fabricator, Welding Engineer, TIG Welder, MIG Welder, Steel Welder,",
            "priority": "106",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Wheelie Bin Cleaner",
            "webBranding": "CAQTL",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Will Writing",
            "webBranding": "CAQSC",
            "keywords": "0",
            "priority": "1000",
            "products": "CAQPI,CAQSC"
        },
        {
            "description": "Window Cleaner",
            "webBranding": "CAQTL",
            "keywords": "Cleaning Contractor, Glass Cleaner",
            "priority": "142",
            "products": "CAQCA,CAQGT,CAQTL"
        },
        {
            "description": "Window Cleaners - water fed pole method",
            "webBranding": "CAQTL",
            "keywords": "Cleaning Contractor, Glass Cleaner, Pressure Wash Cleaning",
            "priority": "143",
            "products": "CAQTL"
        },
        {
            "description": "Woodburning Stove Installation",
            "webBranding": "CAQTL",
            "keywords": "Biomass Boiler Installers, Renewable Energy, Flue Installation",
            "priority": "77",
            "products": "CAQTL"
        },
        {
            "description": "Word Processing",
            "webBranding": "CAQSC",
            "keywords": "Typists",
            "priority": "1000",
            "products": "CAQSC,CAQPI"
        },
        {
            "description": "Acoustic Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Adult Bookstore",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Agricultural Contractor",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQGT,CAQTL"
        },
        {
            "description": "Amusements",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Antique Furniture Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Antique/Rare Book Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Antiques Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Aquarium Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Architectural Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Art Gallery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Art Restoration",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Artist Materials Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Arts & Crafts Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Audio / Visual Media Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Audio, Visual Installation and Repairs",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQTL"
        },
        {
            "description": "Baby Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Babywear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Baker",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bakers Produce Retailing (excluding Baking)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bakery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Basket And/Or Brushware Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bathroom Equipment Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Beauty Products",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Beauty Salon",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bed Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bedding Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Belts / Scarves / Gloves Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQGT,CAQSI"
        },
        {
            "description": "Bingo Hall",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Blacksmiths",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Boat Hiring",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Boat Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bookmaking - Off Course",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bookselling",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bookselling - Secondhand",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Boutique",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Bridal Wear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Builder (Commercial including shops and offices) - Alteration & Repair",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Builder (Commercial including shops and offices) - New Build",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Builder (Private Dwellings) - Alteration & Repair",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Builder (Private Dwellings) - New Build",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Builders Merchant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Building Contracting",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Bureaux de change",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Burger Bar",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Business Training",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Butcher",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Café",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Café (ex Deep Fat Frying)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Camping and Outdoor Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Candle Dealing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Car Accessory Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Car Radio Dealers inc fitting",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Career Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Carpet (Oriental/Persian) Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Carpet Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cash & Carry",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Catering Equipment Supplying",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Ceramics And Pottery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Chandlery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Charitable Orgs / Councilling",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Charity Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Chauffeur Services",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cheese Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Chemist - Dispensing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Chemist - Non Dispensing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI,CAQSI"
        },
        {
            "description": "Children's Clothing Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Children's Play Centre",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "China And/Or Glassware Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Christmas Goods Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Civil/Consultant Engineering",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Clock & Watch Repair",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Clock & Watch Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Clothing Hire - Fancy Dress",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Clothing Hiring",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Clothing Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Coffee And Tea Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Coffee Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Coin & Medal Dealing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Commodity Broker",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Computer Games Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Computer Programming",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Computer Retailing - Business",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Computer Retailing - General",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Computer Retailing - Home & Games",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Computer Software House",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Computer Supplies",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Computer Training School / Services",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Confectionery Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Consulting Optician",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cosmetics",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Counselling/Advice Centre",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Credit Investigation Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Curios Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Curtain & Blind Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cutlery Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cycle Hiring",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cycle Repairing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Cycle Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "DIY - Including Timber",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "DIY Store",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dairy Products Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dating Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Debt Recovery or Bailiff",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Decorators Merchant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Delicatessen",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Department Store",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Doctor",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Dog Beautician",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dolls/Dolls House Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Double Glazing & Replacement Window Showroom",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Draper",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dress Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Driving school",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Drug Store",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dry Cleaning",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dry Cleaning (Receiving Service)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Dry Cleaning and Laundry (Receiving Service)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Editorial Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Education Advisory Service",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Electric Tool Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Electrical Engineer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Electrical Goods (Domestic) Repair",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Electrical Goods Hiring - Domestic Appliance",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Electrical Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Electrical Goods Retailing - Domestic Appliance",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Electrical Goods Retailing - HI FI Audio TV etc.",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Electrical Goods Retailing - White Goods",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Employment Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Engineers  Precision",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Engraving",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Estate Manager",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Exhibition Management",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Export Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Fabric Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fancy Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Farm Produce Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fashion Accessories Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fashion Boutique",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fashion Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Fashion Designer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Fashion Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fast Food Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Filling Station",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Film Processing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fire Protection Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Fireplace Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fish & Chip Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fishery Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Fishing Tackle Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fishmonger",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Florist",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQGT,CAQSI"
        },
        {
            "description": "Food Store",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Footwear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Forestry Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Forwarding Agent",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Freezer Centre",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Freight Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Freight Forwarder",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Frozen Food Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fuel Efficiency Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Funeral Director",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Fur Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture (Flat Pack) Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture Repairing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture Restoration",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture Retailing - Fitted",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture Retailing - Nursery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furniture Retailing - Second-hand",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Furrier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Garden Centre",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Garden Equipment Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Garden Supplies Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "General Store",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Gift Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Glass Merchant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Glass or Glass Goods Decorator / Engraver",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Glassware Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Goldsmith",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Golf Equipment Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Golf Professionals Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Gown Trade",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Greengrocer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Greeting Card Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Grocer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Grocer - Licensed",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Guest House                                       ",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPO,CAQSI"
        },
        {
            "description": "Gun Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Gunsmith",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Haberdashery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hairdressing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hairpiece And Wig Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Handicraft Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hardware Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hatter",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Health Food Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Heating Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Herbs and Spices Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hobby Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Home Brew Materials Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Horticultural Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hosiery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Hotel Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Hotel                                             ",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Household Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Housing Organisation",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Ice Cream Parlour",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Import / Export Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "In Car Entertainment Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Indoor Roller Skate Rink",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Industrial Safetywear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Insurance Advisor",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Insurance Assessor",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Interior Designer including fitting",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI,CAQSI"
        },
        {
            "description": "Internet Cafe",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Internet Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Introduction Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Intruder Alarm Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Ironmonger",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Jewellery Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Jewellery Design",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Jewellery Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Journalist",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Key Cutter",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Kitchen Accessories Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Kitchen Planner",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Kitchen/Bathroom Unit Showroom",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Knitting Machine Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Knitwear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Lamp Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Land Surveying",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Landscape Design",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Language School",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Launderette (attended)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Launderette (unattended)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Lawn Services",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Lease Broking",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Leather Clothing Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Leather Goods Retailing - Excluding Clothes",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Leather Goods Retailing - Including Clothes",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Leather and Travel Goods",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Leisurewear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Light Fitting Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Lighting Consultant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Lighting Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Linen Hire",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Linen Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Lingerie Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Loss Adjusting",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Loss Assessing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Lottery Agent",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Luggage and Handbag Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Management Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Management Training",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Marine Stores",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Market Research",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Marriage Guidance",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Maternity Wear Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Meat Market",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Menswear Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Millinery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Mini Cab Operator",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Mobile Phone Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Mobile Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Model Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Motor Accessories Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Motor Accessories Retailing (excl In-Car Entertainment)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Motor Trade",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Motorcycle Accessories Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Music Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Music School",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Musical Instrument Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Newsagent",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "None",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQCA,CAQTL"
        },
        {
            "description": "Novelty/Carnival Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Nursery Goods Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Nursery School",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Occupational Therapy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Off Licence",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Office Equipment Supplier (excluding Electrical)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Office Equipment Supplier (including Electrical)",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Office Furniture Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Office Supplies Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Organic Foods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Orthopaedic Equipment Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Paint And/Or Wallpaper Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Paint Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Party Planner",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Patent/Trademark Agent",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Pawnbroking",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pens Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Perambulator Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Perfume Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Personnel Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Pet Accessory/Food Store",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pet Parlour",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pet Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Petrol Station",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pharmaceutical Wholesaler",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pharmacy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Photo Engraving",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Photo Processing And Printing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Photocopying",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Photographic Equipment Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Photographic Studio",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Piano Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Piano Retailing And Repair",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Picture Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pine And Cane Furniture Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pizza Delivery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Plastics Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Play Equipment Fitter",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Plumbers Merchant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Political Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Pool and Snooker Table Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Post Office",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Post Office - Sub",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Post Office Services",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Pottery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Poultry And Game Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Print Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Property Management",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Public House",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Public School",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Record CD Cassette & Video/DVD Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Record Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Registrar",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Relocation Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Restaurant - Licensed",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Restaurant - unlicensed",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Rope Merchant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Saddlery And Tack Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Safety Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Safety Equipment Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Sailing Equipment Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Sandwich Bar",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Scientific Instrument Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Scrap Metal Merchant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Second-hand Dealing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Secretarial Training",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Sewing / Knitting Machine Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Sewing Machine Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Sex Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Sharpening Service",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Shipping And Forwarding Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Shirt Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Shoe Repairing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Shoe Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Silversmith",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Silverware Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Slimming Clinic",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Sofa Bed Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Soft Furnishings Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Software Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Software Engineering",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Souvenir Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Sports Goods Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Sportswear Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Stamp Collecting Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Stationer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Stocktaking",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Street/Market Trading",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Structural Engineering",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Sunday School",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Supermarket",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Surface Coating Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Surgical Equipment Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Surveyor",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Sweet Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "TV And Radio",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "TV And Video Rental",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tableware Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tachograph Analysis",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Tailor And Outfitter",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Take Away Food Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Takeaways",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tea Room",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Telecommunication Equipment Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Telephone Sales Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Television Hiring",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Television Repairing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Television Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Textile Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tile Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tobacconist",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Toiletries Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tool Hire",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tool Hire - Hand",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tool Hire - Power Driven",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tool Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tourist Information",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Toy And Game Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Traffic Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Training Advisory Service",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Translation Bureaux",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Travel Agency",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Travel Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Trophy Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Tuition",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Turf Accountant",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Typing and Copying Bureaux",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": ""
        },
        {
            "description": "Tyre Battery & Exhaust Retailing/Fitter",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Undertaker",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "University",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Upholstery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Venetian Blind Supplier",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Video/DVD Hire",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Wallpaper Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Watch And Clock Retailing",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Wine Retailer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Wool And Needlework Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Woollen Goods Shop",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Yacht Chandlery",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQSI"
        },
        {
            "description": "Youth Counselling Service",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Zoology Consultancy",
            "priority": "1000",
            "keywords": "",
            "webBranding": "",
            "products": "CAQPI"
        },
        {
            "description": "Wind Turbine Installation",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Welding and Fabrication",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Water Treatment",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Heavy Plant Operators",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Powder Coatings",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Video Services",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Domestic Oven Cleaner",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Pools Collector",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Suspended Ceiling Contractors",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL,CAQSC"
        },
        {
            "description": "Waste Removal",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL"
        },
        {
            "description": "Meter Reader",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQTL",
            "products": "CAQTL"
        },
        {
            "description": "Children's Entertainer",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQSC",
            "products": "CAQSC"
        },
        {
            "description": "Mobile DJ",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQSC",
            "products": "CAQSC"
        },
        {
            "description": "Party Planner",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQSC",
            "products": "CAQSC"
        },
        {
            "description": "Party Planner inc Hire and Supply",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQSC",
            "products": "CAQSC"
        },
        {
            "description": "Project Manager Non Manual",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQSC",
            "products": "CAQSC"
        },
        {
            "description": "Site Supervisor",
            "priority": "1000",
            "keywords": "",
            "webBranding": "CAQSC",
            "products": "CAQSC"
        },
        {
            "description": "Typewriter Services",
            "webBranding": "CAQSC",
            "keywords": "Typewriter Services",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Property Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Property Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Typing and Copying Bureaux",
            "webBranding": "CAQSC",
            "keywords": "Typing and Copying Bureaux",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Cameraman",
            "webBranding": "CAQSC",
            "keywords": "Cameraman",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Barber",
            "webBranding": "CAQSC",
            "keywords": "Barber",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Parcel Delivery",
            "webBranding": "CAQSC",
            "keywords": "Parcel Delivery",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Hospital Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Hospital Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Stocktaker / Inventory Consultants",
            "webBranding": "CAQSC",
            "keywords": "Stocktaker / Inventory Consultants",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Computer Graphics",
            "webBranding": "CAQSC",
            "keywords": "Computer Graphics",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Home Crafts",
            "webBranding": "CAQSC",
            "keywords": "Home Crafts",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Telemarketer",
            "webBranding": "CAQSC",
            "keywords": "Telemarketer",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Sports/Personal Training",
            "webBranding": "CAQSC",
            "keywords": "Sports/Personal Training",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Illustrator",
            "webBranding": "CAQSC",
            "keywords": "Illustrator",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Toast-mastering",
            "webBranding": "CAQSC",
            "keywords": "Toast-mastering",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Speech Therapy",
            "webBranding": "CAQSC",
            "keywords": "Speech Therapy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Computer Aided Design",
            "webBranding": "CAQSC",
            "keywords": "Computer Aided Design",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Scientific Research",
            "webBranding": "CAQSC",
            "keywords": "Scientific Research",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Sandwich Bar",
            "webBranding": "CAQSC",
            "keywords": "Sandwich Bar",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Lawyers",
            "webBranding": "CAQSC",
            "keywords": "Lawyers",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Inventory Clerks",
            "webBranding": "CAQSC",
            "keywords": "Inventory Clerks",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Caterer",
            "webBranding": "CAQSC",
            "keywords": "Caterer",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fashion Designer",
            "webBranding": "CAQSC",
            "keywords": "Fashion Designer",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fire Protection Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Fire Protection Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fishery Consultant",
            "webBranding": "CAQSC",
            "keywords": "Fishery Consultant",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Nail Technician",
            "webBranding": "CAQSC",
            "keywords": "Nail Technician",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Personnel Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Personnel Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Property Management",
            "webBranding": "CAQSC",
            "keywords": "Property Management",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Software Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Software Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Career Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Career Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Computer Programming",
            "webBranding": "CAQSC",
            "keywords": "Computer Programming",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fashion Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Fashion Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Forestry Consultant",
            "webBranding": "CAQSC",
            "keywords": "Forestry Consultant",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Fuel Efficiency Consultant",
            "webBranding": "CAQSC",
            "keywords": "Fuel Efficiency Consultant",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Hotel Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Hotel Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Import / Export Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Import / Export Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Insurance Advisor",
            "webBranding": "CAQSC",
            "keywords": "Insurance Advisor",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Insurance Assessor",
            "webBranding": "CAQSC",
            "keywords": "Insurance Assessor",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Internet Consultant",
            "webBranding": "CAQSC",
            "keywords": "Internet Consultant",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Land Surveying",
            "webBranding": "CAQSC",
            "keywords": "Land Surveying",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Loss Adjusting",
            "webBranding": "CAQSC",
            "keywords": "Loss Adjusting",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Loss Assessing",
            "webBranding": "CAQSC",
            "keywords": "Loss Assessing",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Management Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Management Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Market Research",
            "webBranding": "CAQSC",
            "keywords": "Market Research",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Plastics Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Plastics Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Tuition",
            "webBranding": "CAQSC",
            "keywords": "Tuition",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Project Manager",
            "webBranding": "CAQSC",
            "keywords": "Project Manager",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Market Trader",
            "webBranding": "CAQSC",
            "keywords": "Market Trader",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Dog Beautician",
            "webBranding": "CAQSC",
            "keywords": "Dog Beautician",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Musician",
            "webBranding": "CAQSC",
            "keywords": "Musician",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Design Consultancy / Services",
            "webBranding": "CAQSC",
            "keywords": "Design Consultancy / Services",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Agronomist",
            "webBranding": "CAQSC",
            "keywords": "Agronomist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Drama Instruction",
            "webBranding": "CAQSC",
            "keywords": "Drama Instruction",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Astrology",
            "webBranding": "CAQSC",
            "keywords": "Astrology",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Health Advice Service",
            "webBranding": "CAQSC",
            "keywords": "Health Advice Service",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Geneticist",
            "webBranding": "CAQSC",
            "keywords": "Geneticist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Driving Instructor",
            "webBranding": "CAQSC",
            "keywords": "Driving Instructor",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Insurance",
            "webBranding": "CAQSC",
            "keywords": "Insurance",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Surveyor                                          ",
            "webBranding": "CAQSC",
            "keywords": "Surveyor                                          ",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Art Criticism",
            "webBranding": "CAQSC",
            "keywords": "Art Criticism",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Archivist",
            "webBranding": "CAQSC",
            "keywords": "Archivist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Secretarial Service/Staff",
            "webBranding": "CAQSC",
            "keywords": "Secretarial Service/Staff",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Refuse Treatment Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Refuse Treatment Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Property managers / letting agents",
            "webBranding": "CAQSC",
            "keywords": "Property managers / letting agents",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Industrial Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Industrial Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Business Advisory Service",
            "webBranding": "CAQSC",
            "keywords": "Business Advisory Service",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Electronics Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Electronics Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Food Industry Consultant",
            "webBranding": "CAQSC",
            "keywords": "Food Industry Consultant",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "After dinner speaking",
            "webBranding": "CAQSC",
            "keywords": "After dinner speaking",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Hygiene And Cleansing Services",
            "webBranding": "CAQSC",
            "keywords": "Hygiene And Cleansing Services",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Food Hygiene Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Food Hygiene Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Company Search Agent",
            "webBranding": "CAQSC",
            "keywords": "Company Search Agent",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Carer",
            "webBranding": "CAQSC",
            "keywords": "Carer",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Environmental Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Environmental Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Florist",
            "webBranding": "CAQSC",
            "keywords": "Florist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Tailor And Outfitter",
            "webBranding": "CAQSC",
            "keywords": "Tailor And Outfitter",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Pet Minding",
            "webBranding": "CAQSC",
            "keywords": "Pet Minding",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Human Resources Consultants",
            "webBranding": "CAQSC",
            "keywords": "Human Resources Consultants",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Astronomy",
            "webBranding": "CAQSC",
            "keywords": "Astronomy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Pipeline Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Pipeline Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Flower/Plant Arrangers",
            "webBranding": "CAQSC",
            "keywords": "Flower/Plant Arrangers",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Aerobic Instructing",
            "webBranding": "CAQSC",
            "keywords": "Aerobic Instructing",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Rating And Valuation",
            "webBranding": "CAQSC",
            "keywords": "Rating And Valuation",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Choreography",
            "webBranding": "CAQSC",
            "keywords": "Choreography",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Proof Reader",
            "webBranding": "CAQSC",
            "keywords": "Proof Reader",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Legal Services",
            "webBranding": "CAQSC",
            "keywords": "Legal Services",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Commodity Broker",
            "webBranding": "CAQSC",
            "keywords": "Commodity Broker",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Commercial Artist",
            "webBranding": "CAQSC",
            "keywords": "Commercial Artist",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Delivery Service",
            "webBranding": "CAQSC",
            "keywords": "Delivery Service",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Sales Promotion Consultants",
            "webBranding": "CAQSC",
            "keywords": "Sales Promotion Consultants",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Business Consultants",
            "webBranding": "CAQSC",
            "keywords": "Business Consultants",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Planning Consultants",
            "webBranding": "CAQSC",
            "keywords": "Planning Consultants",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Mini Cab Operator",
            "webBranding": "CAQSC",
            "keywords": "Mini Cab Operator",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Sewage Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Sewage Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Engineering Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Engineering Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Colour Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Colour Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Data Processors",
            "webBranding": "CAQSC",
            "keywords": "Data Processors",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Pension Consultant",
            "webBranding": "CAQSC",
            "keywords": "Pension Consultant",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "IT consultants",
            "webBranding": "CAQSC",
            "keywords": "IT consultants",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Professional or Admin - Tools cover not available",
            "webBranding": "CAQSC",
            "keywords": "Professional or Admin - Tools cover not available",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Promotional Consultancy",
            "webBranding": "CAQSC",
            "keywords": "Promotional Consultancy",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Taxi Operator",
            "webBranding": "CAQSC",
            "keywords": "Taxi Operator",
            "priority": "1000",
            "products": "CAQSC"
        },
        {
            "description": "Grounds maintenance",
            "webBranding": "CAQTL",
            "keywords": "Grounds maintenance",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Point Of Sale & Display � Installation",
            "webBranding": "CAQTL",
            "keywords": "Point Of Sale & Display � Installation",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "PAT Testers",
            "webBranding": "CAQTL",
            "keywords": "PAT Testers",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Fence Erecting",
            "webBranding": "CAQTL",
            "keywords": "Fence Erecting",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Pipe Laying",
            "webBranding": "CAQTL",
            "keywords": "Pipe Laying",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Park Keeper",
            "webBranding": "CAQTL",
            "keywords": "Park Keeper",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Draught Proofing",
            "webBranding": "CAQTL",
            "keywords": "Draught Proofing",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Glaziers",
            "webBranding": "CAQTL",
            "keywords": "Glaziers",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Electrical Engineer",
            "webBranding": "CAQTL",
            "keywords": "Electrical Engineer",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Lawn Services",
            "webBranding": "CAQTL",
            "keywords": "Lawn Services",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "House & Garden Removals",
            "webBranding": "CAQTL",
            "keywords": "House & Garden Removals",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Welder & Mechanics",
            "webBranding": "CAQTL",
            "keywords": "Welder & Mechanics",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Vehicle Mechanic Including Welding and Fabrication",
            "webBranding": "CAQTL",
            "keywords": "Vehicle Mechanic Including Welding and Fabrication",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Farm Worker",
            "webBranding": "CAQTL",
            "keywords": "Farm Worker",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Calibration consultancy",
            "webBranding": "CAQTL",
            "keywords": "Calibration consultancy",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Picture Framing",
            "webBranding": "CAQTL",
            "keywords": "Picture Framing",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Glass or Glass Goods Decorator / Engraver",
            "webBranding": "CAQTL",
            "keywords": "Glass or Glass Goods Decorator / Engraver",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Pipe Insulator",
            "webBranding": "CAQTL",
            "keywords": "Pipe Insulator",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Stained Glass Fitters",
            "webBranding": "CAQTL",
            "keywords": "Stained Glass Fitters",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Drainage",
            "webBranding": "CAQTL",
            "keywords": "Drainage",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Corrosion Consultant",
            "webBranding": "CAQTL",
            "keywords": "Corrosion Consultant",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Handyman",
            "webBranding": "CAQTL",
            "keywords": "Handyman",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Leaded Lights and Windows - Fitting",
            "webBranding": "CAQTL",
            "keywords": "Leaded Lights and Windows - Fitting",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Construction Plant Repairer",
            "webBranding": "CAQTL",
            "keywords": "Construction Plant Repairer",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Shelving And Racking Installation",
            "webBranding": "CAQTL",
            "keywords": "Shelving And Racking Installation",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Cable Contracting",
            "webBranding": "CAQTL",
            "keywords": "Cable Contracting",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Door Fitter",
            "webBranding": "CAQTL",
            "keywords": "Door Fitter",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Wood Carving",
            "webBranding": "CAQTL",
            "keywords": "Wood Carving",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Television Repairing",
            "webBranding": "CAQTL",
            "keywords": "Television Repairing",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Electrician Industrial",
            "webBranding": "CAQTL",
            "keywords": "Electrician Industrial",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Thermal Insulation",
            "webBranding": "CAQTL",
            "keywords": "Thermal Insulation",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Ventilation",
            "webBranding": "CAQTL",
            "keywords": "Ventilation",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Shoe Repairing",
            "webBranding": "CAQTL",
            "keywords": "Shoe Repairing",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Signwriting",
            "webBranding": "CAQTL",
            "keywords": "Signwriting",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Fireplace Installation",
            "webBranding": "CAQTL",
            "keywords": "Fireplace Installation",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "High Pressure Jet Washing",
            "webBranding": "CAQTL",
            "keywords": "High Pressure Jet Washing",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Labourer",
            "webBranding": "CAQTL",
            "keywords": "Labourer",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Office Fitter",
            "webBranding": "CAQTL",
            "keywords": "Office Fitter",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Telecommunication and Data",
            "webBranding": "CAQTL",
            "keywords": "Telecommunication and Data",
            "priority": "1000",
            "products": "CAQTL"
        },
        {
            "description": "Washing Machine Repairs And Servicing",
            "webBranding": "CAQTL",
            "keywords": "Washing Machine Repairs And Servicing",
            "priority": "1000",
            "products": "CAQTL"
        }
    ];

    return trades;

}

export const GetTradeByName = (tradeName: string) => {
    let trades = GetTrades();
    tradeName = tradeName.replaceAll("+", " ").replaceAll("%26", "&").replaceAll("%2f", "/").replaceAll("%c3%a9", "�").replaceAll("%27", "'").replaceAll("%e2%80%99", "'").replaceAll("%2c", ",").toLowerCase();

    let trade = trades.find(x => x.description.toLowerCase().trim() === tradeName && x.webBranding !== "");

    if (trade === undefined) {
        trade = {
            "description": tradeName,
            "webBranding": "CAQTL",
            "keywords": "customadded",
            "priority": "1",
            "products": "CAQTL"
        }
    }
    return trade;
}

export const GetTradesByProduct = (webBranding: string) => {
    let trades = GetTrades();

    trades = trades.sort((a, b) =>
        a.description > b.description ? 1 : -1,
    );

    return trades.filter(x => x.products.toLowerCase().includes(webBranding.toLowerCase()));
}

export const GetTradesFromQuestion = () => {
    let storedQuestions = localStorage.getItem('questions');
    let webReference = localStorage.getItem('webReference') || "";
    let trades: any = [];
    if (storedQuestions != null) {
        let questionSet = JSON.parse(storedQuestions);

        let tradeQuestion = questionSet.filter((x: { questionSetQuestion: { text: string; }; }) => x.questionSetQuestion.text.toLowerCase() === "what is your main trade?")[0]
        if (tradeQuestion !== undefined) {
            tradeQuestion.answerList.map((trade: any) => {
                let tradeObject = {
                    "description": trade.text,
                    "priority": "1000",
                    "keywords": "",
                    "webBranding": webReference,
                    "products": webReference
                };

                trades.push(tradeObject);

                return trade;
            });
        }
    }

    return trades;
}